import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RouteUtils} from '@lifeislife/lifeislife-components';
import {combineLatest, Observable, of, Subscription} from 'rxjs';
import {CustomerContextService} from '../../service/customer-context-service';
import {CustomerContact, Ref, SigningPackageService, UserAuthService} from '@lifeislife/lifeislife-domain';
import {debounceTime, delay, filter, map, publishReplay, refCount, switchMap} from 'rxjs/operators';

@Component({
  selector: 'cf-package-signed-route',
  templateUrl: './package-signed-route.component.html',
  styleUrls: ['./package-signed-route.component.scss'],
})
export class PackageSignedRouteComponent implements OnInit, OnDestroy {

  loggedIn$: Observable<boolean>;

  private signingPackageIdParam$: Observable<string>;
  signingPackageStatusParam$: Observable<string>;
  signingPackageSignedParam$: Observable<boolean>;
  signingPackageRejectedParam$: Observable<boolean>;

  private subscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerContextService: CustomerContextService,
    private userAuthService: UserAuthService,
    private signingPackageService: SigningPackageService,
  ) {
  }

  ngOnInit(): void {
    this.subscription = new Subscription();
    this.signingPackageIdParam$ = RouteUtils.getRouteParam('signingPackageId', this.activatedRoute);
    this.signingPackageStatusParam$ = RouteUtils.getRouteParam('signingPackageStatus', this.activatedRoute);
    this.signingPackageSignedParam$ = RouteUtils.getRouteParam('signingPackageSigned', this.activatedRoute)
      .pipe(map(b => b === 'true'), publishReplay(1), refCount());
    this.signingPackageRejectedParam$ = RouteUtils.getRouteParam('signingPackageRejected', this.activatedRoute)
      .pipe(map(b => b === 'true'), publishReplay(1), refCount());

    this.loggedIn$ = this.userAuthService.user$.pipe(
      switchMap(u => u == null ? of(false) : of(true)),
      publishReplay(1), refCount(),
    );

    // Refetch status from backend, so that backend refresh status from signhere, as it seems race condition occur here,
    // with the last status check done when redirecting to this page sometimes still returning 'InProgress'.
    const refetchStatusSusbcription = this.signingPackageIdParam$.pipe(
      debounceTime(2000),
      filter(id => id != null),
      map(id => parseInt(id, 10)),
      filter(id => !isNaN(id)),
      switchMap(id => this.signingPackageService.anonymousRefreshPackageStatus(id)),
    ).subscribe();
    this.subscription.add(refetchStatusSusbcription);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
